/*
 * $Id:: UserInfo.js 2020/11/12 06:07 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useState, useEffect } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux';

import { SLICE_NAME } from '../../pages/MyAccountPage/constants';
import { setLocale } from '../../providers';
import LanguageSelect from '../LanguageSelect';
import UserAvatarMenu from './UserAvatarMenu';

const useStyles = makeStyles((theme) => ({
    headerRightSection: {
        display: 'flex',
        flexFlow: 'row wrap',
        alignItems: 'center',
        justifyContent: 'flex-end',
        '@media (max-width:1100px)': {
            flexFlow: 'row nowrap',
        },
    },
    headerUser: {
        display: 'flex',
        flexFlow: 'row wrap',
        alignItems: 'center',
        justifyContent: 'flex-end',
        marginLeft: '30px',
        '@media (max-width:1100px)': {
            marginLeft: '10px',
            justifyContent: 'center',
        },
        '@media (max-width:1010px)': {
            marginLeft: '0px',
        },
    },
    userArea: {
        display: 'flex',
        flexFlow: 'row nowrap',
    },
    language: {
        display: 'flex',
        flexFlow: 'row nowrap',
        marginRight: '22px',
    },
    userInfo: {
        marginLeft: '10px',
        display: 'inline-grid',
    },
    userRole: {
        color: '#4D4D4D',
        lineHeight: '12.5px',
        letterSpacing: '0.4px',
        fontSize: '0.625rem',
        fontWeight: '400',
    },
    logout: {
        height: '2.5rem',
        minWidth: '4.5rem',
        color: theme.palette.primary.main + ' !important', //
        border: '1px solid ' + theme.palette.primary.main,
        fontWeight: '600',
        fontSize: '0.875rem',
        lineHeight: '133%',
        letterSpacing: '1.5px',
        textTransform: 'uppercase',
        borderRadius: '2px',
    },
}));

const UserInfo = ({ user, logout, languages, language, smallDevice, myAccountLink }) => {
    const classes = useStyles();
    const accountDetails = user.userDetails && user.userDetails.accountTypeDetails;
    const dispatch = useDispatch();
    const [lang, setLang] = useState(language);
    const [langSelectorIsOpen, setLangSelectorIsOpen] = useState(false);
    const [keyEvent, setKeyEvent] = useState(null);

    useEffect(() => {
        setLang(language);
    }, [language]);

    const updateLanguage = (event) => {
        const value = event.target.value;
        if (lang === value) return;
        dispatch({ type: `${SLICE_NAME}/updateLanguage`, payload: { language: value } });
        setLang(value);
        let myStorage = window.sessionStorage;
        myStorage.setItem('lang', value);
        setLocale(value);
        const languageSelect = document.getElementById('lng-select');
        if (keyEvent === 'Escape' || keyEvent === 'Enter') {
            languageSelect.focus();
        }
    };
    //  set role
    let role = '';
    if (user.userRole) {
        role = user.userRole;
    } else {
        if (user.userType === 'CHILD' && accountDetails) {
            role = accountDetails.personType;
        }
    }

    const [pt, en] = languages;
    const langList = [{ pt, en }];

    const languageSelectOpen = (e) => {
        setLangSelectorIsOpen(true);
        if (e.key === 'Enter') {
            const unSelectedLang = languages.filter((language) => lang !== language.code);
            setTimeout(() => {
                document.getElementById(`${unSelectedLang[0].code}_btn`).focus();
            }, 200);
        }
    };

    useEffect(() => {
        if (langSelectorIsOpen) {
            document.addEventListener('keydown', handleEscapeKey);
        }
    }, [langSelectorIsOpen]);

    const handleEscapeKey = (event) => {
        setKeyEvent(event.key);
    };

    const languageSelectClose = () => {
        setLangSelectorIsOpen(false);
    };

    return (
        <div className={classes.headerRightSection} data-testid="UserInfoTestId">
            <div className={classes.headerUser}>
                {!smallDevice && (
                    <div className={classes.language}>
                        <LanguageSelect
                            languages={languages}
                            updateLanguage={updateLanguage}
                            langSelectorIsOpen={langSelectorIsOpen}
                            lang={lang}
                            languageSelectClose={languageSelectClose}
                            languageSelectOpen={languageSelectOpen}
                        />
                    </div>
                )}
                <div className={classes.userArea}>
                    <UserAvatarMenu user={user} logout={logout} lang={lang} myAccountLink={myAccountLink} />
                </div>
            </div>
        </div>
    );
};

export default UserInfo;
